<template>
    <VueFinalModal
        content-transition="slide-up"
        content-class="h-full"
        :lock-scroll="false"
        :reserve-scroll-bar-gap="false">
        <div class="relative flex h-full w-screen cursor-pointer items-center justify-center overflow-hidden">
            <div class="relative m-auto size-full cursor-auto bg-white">
                <Cart />
                <ModalCloseButton class="right-6 top-7 z-50" @click="emit('close')" />
            </div>
        </div>
    </VueFinalModal>
</template>

<script setup lang="ts">
    import { VueFinalModal } from 'vue-final-modal'
    import Cart from '~/components/Cart/Cart.vue'
    import ModalCloseButton from './ModalCloseButton.vue'
    const emit = defineEmits<{
        (e: 'close'): void
    }>()
</script>
